var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.active}})])
}
var staticRenderFns = []

export { render, staticRenderFns }